module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "epigraphPage"
  }, [_c('a', {
    attrs: {
      "id": "title36"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("No se puede mirar.")]), _vm._v(" One cannot look at this."), _c('br'), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Yo lo vi")]), _vm._v(". I saw it. "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Esto es lo verdadero.")]), _vm._v(" This is the truth.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "source"
  }, [_c('span', [_vm._v("—FRANCISCO GOYA")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ff98add","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429923200_epi01.vue
// module id = 66
// module chunks = 0